import { trackEvent } from "@pb/utils/tracking";
const trackVideoEvent = (trackingType, { articleCode, video_played_time, video_total_duration }) => {
    const trackingData = {
        event_type: 'PDP_INTERACTION_VIDEO',
        event_category: 'Product interactions',
        event_label: articleCode,
        video_played_time,
        video_total_duration,
    };
    switch (trackingType) {
        case 'videostart':
            trackEvent(Object.assign(Object.assign({}, trackingData), { event_id: 'Start video' }));
            break;
        case 'videopause':
            trackEvent(Object.assign(Object.assign({}, trackingData), { event_id: 'Pause video' }));
            break;
        case 'videocomplete':
            trackEvent(Object.assign(Object.assign({}, trackingData), { event_id: 'Video completed' }));
            break;
        case 'videoleavepdp':
            trackEvent(Object.assign(Object.assign({}, trackingData), { event_id: 'Video leave pdp' }));
            break;
        default:
    }
};
export const trackVideo = (videoElement, duration = 0, articleCode = '') => {
    if (!videoElement) {
        return;
    }
    let iterations = 0;
    let totalTimePlayed = 0;
    const updateTimePlayed = () => {
        if (videoElement) {
            totalTimePlayed = iterations * duration + videoElement.currentTime;
        }
    };
    const handleVideoPlayEvent = () => {
        updateTimePlayed();
        trackVideoEvent('videostart', {
            articleCode,
            video_played_time: totalTimePlayed.toString(),
            video_total_duration: duration.toString(),
        });
    };
    const handleVideoPauseEvent = () => {
        updateTimePlayed();
        trackVideoEvent('videopause', {
            articleCode,
            video_played_time: totalTimePlayed.toString(),
            video_total_duration: duration.toString(),
        });
    };
    const trackVideoComplete = () => {
        updateTimePlayed();
        trackVideoEvent('videocomplete', {
            articleCode,
            video_played_time: totalTimePlayed.toString(),
            video_total_duration: duration.toString(),
        });
    };
    const handleVideoLeavePdp = () => {
        updateTimePlayed();
        trackVideoEvent('videoleavepdp', {
            articleCode,
            video_played_time: totalTimePlayed.toString(),
            video_total_duration: duration.toString(),
        });
    };
    const handleSeekingEvent = () => {
        if (videoElement.currentTime < 0.5) {
            iterations += 1;
            updateTimePlayed();
            trackVideoComplete();
        }
    };
    videoElement.addEventListener('play', handleVideoPlayEvent);
    videoElement.addEventListener('pause', handleVideoPauseEvent);
    videoElement.addEventListener('seeking', handleSeekingEvent);
    videoElement.addEventListener('beforeunload', handleVideoLeavePdp);
};
//# sourceMappingURL=tracking.js.map